import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { isNonEmptyString } from "../../../utils/ValidationHelp";

export const InputField = ({
  onChange,
  placeholder,
  value,
  triggerChecking,
}: {
  onChange: (value?: string | number) => void;
  placeholder?: string;
  value?: string | number;
  triggerChecking?: boolean;
}) => {
  const intl = useIntl();
  const [isShowError, setIsShowError] = useState(false);

  useEffect(() => {
    if (triggerChecking) {
      setIsShowError(true);
    }
  }, [triggerChecking]);

  return (
    <div className="mb-4">
      <label className="block text-[#6e5f49]">{placeholder}</label>
      <input
        className={`w-full px-3 py-2 leading-tight text-gray-700 border-2 border-[#5f523d] rounded shadow appearance-none focus:outline-none ${
          !isNonEmptyString(value) && isShowError
            ? "border-red-800 focus:border-red-900"
            : "focus:border-[#6f6149] "
        }`}
        type="text"
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => setIsShowError(true)}
        value={value}
        placeholder={placeholder}
      />
      {!isNonEmptyString(value) && isShowError && (
        <div className="text-red-900">
          {intl.formatMessage({ id: "fieldIsRequired" })}
        </div>
      )}
    </div>
  );
};
